import * as _ from 'lodash';
import moment from 'moment';

export class UtilityService {

    static provideFullNameFirstNameFirst(name: any, professions?: string[], specialties?: string[]): string {
        let nameDesc: string;
        if (name) {
            if (name.firstName) nameDesc = name.firstName;
            if (name.middleName) nameDesc = nameDesc + ' ' + name.middleName.substr(0, 1) + '.';
            if (name.lastName) nameDesc = nameDesc + ' ' + name.lastName;
            if (name.suffix) nameDesc = nameDesc + ', ' + name.suffix;
            if (professions && professions.length > 0) {
                let professionsDesc: string = this.provideProfessions(professions);
                nameDesc = nameDesc + (professionsDesc.trim().length > 0 ? (', ' + professionsDesc) : '');
            }
            if (specialties && specialties.length > 0) {
                let specialtiesDesc: string = this.provideSpecialties(specialties);
                nameDesc = nameDesc + (specialtiesDesc.trim().length > 0 ? (', ' + specialtiesDesc) : '');
            }
        }

        return nameDesc;
    }

    static provideFullNameLastNameFirst(name: any, professions?: string[], specialties?: string[]): string {
        let nameDesc: string;
        if (name) {
            if (name.lastName) nameDesc = name.lastName;
            if (name.firstName) nameDesc = nameDesc + ', ' + name.firstName;
            if (name.middleName) nameDesc = nameDesc + ' ' + name.middleName.substr(0, 1) + '.';
            if (name.suffix) nameDesc = nameDesc + ', ' + name.suffix;
            if (professions && professions.length > 0) {
                let professionsDesc: string = this.provideProfessions(professions);
                nameDesc = nameDesc + (professionsDesc.trim().length > 0 ? (', ' + professionsDesc) : '');
            }
            if (specialties && specialties.length > 0) {
                let specialtiesDesc: string = this.provideSpecialties(specialties);
                nameDesc = nameDesc + (specialtiesDesc.trim().length > 0 ? (', ' + specialtiesDesc) : '');
            }
        }

        return nameDesc;
    }

    static provideProfessions(professions: string[]): string {
        let name: string = '';
        if (professions && professions.length > 0) {
            let newProfessions: string[] = [];
            for (let key in professions)
                newProfessions.push(professions[key]);

            name = newProfessions.join(", ");
        }

        return name;
    }

    static provideSpecialties(specialties?: string[]): string {
        let name: string = '';
        if (specialties && specialties.length > 0) {
            let newSpecialties: string[] = [];
            for (let key in specialties)
                newSpecialties.push(specialties[key]);

            name = newSpecialties.join(", ");
        }

        return name;
    }

    static sortListByKey(records: any[], isAscending: boolean, sortKey: string): any[] {
        let sortedArray: any[] = records.sort((p1: any, p2: any) => {
            let a: string;
            let b: string;

            if (p1[sortKey])
                a = p1[sortKey];
            else
                return 0;

            if (p2[sortKey])
                b = p2[sortKey];
            else
                return 0;

            if (isAscending) {
                return a > b ? 1 : -1
            } else {
                return a < b ? 1 : -1
            }
        });

        return sortedArray;
    }

    static sortListByDate(records: any[], isAscending: boolean, sortKey: string): any[] {
        let sortedArray: any[] = records.sort((p1: any, p2: any) => {
            let created1: string;
            let created2: string;
            if (p1[sortKey])
                created1 = p1[sortKey];
            else if (p1.createdAt)
                created1 = p1.createdAt;
            else return 0;

            if (p2[sortKey])
                created2 = p2[sortKey];
            else if (p2.createdAt)
                created2 = p2.createdAt;
            else return 0;

            let age1: number = moment(created1).toDate().getTime();
            let age2: number = moment(created2).toDate().getTime();

            if (isAscending) {
                if (age2 == age1)
                    return 0;
                else if (age2 > age1)
                    return -1;
                else
                    return 1;
            } else {
                if (age1 == age2)
                    return 0;
                else if (age1 > age2)
                    return -1;
                else
                    return 1;
            }
        });

        return sortedArray;
    }



    static romanize(num: number) {
        var lookup = { M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1 },
            roman = '',
            i;
        for (i in lookup) {
            while (num >= lookup[i]) {
                roman += i;
                num -= lookup[i];
            }
        }
        return roman;
    }
}